import {
	Button,
	DialogActions,
	DialogContent,
	DialogTitle,
} from "@mui/material"
import {useDispatch, useSelector} from "react-redux"
import {
	clearManageWorkspaceView,
	fetchAuthorInviteDTOsForWorkspace,
	selectAuthorInviteDTOs
} from "../../reducers/manageWorkspaceSlice"
import {useEffect} from "react"
import {ManageModalContainer} from "./shared_components/ManageModalContainer"
import ListOfUsers from "./shared_components/ListOfUsers"

export function ManageWorkspaceInvites() {
	const authorInviteDTOs = useSelector(selectAuthorInviteDTOs)
	const dispatch = useDispatch()

	useEffect(() => {
		dispatch(fetchAuthorInviteDTOsForWorkspace())
	}, [])

	return (
		<ManageModalContainer>
			<DialogTitle> Authors invited to this workspace </DialogTitle>
			<DialogContent>
				{authorInviteDTOs &&
					<ListOfUsers members={authorInviteDTOs} displayingInvites={true} />
				}
			</DialogContent>
			<DialogActions>
				<Button
					onClick={() => dispatch(clearManageWorkspaceView())}
					variant={"outlined"}
					color={"error"}
				>
					Cancel
				</Button>
			</DialogActions>
		</ManageModalContainer>
	)
}